import { useMemo, useEffect } from "@wordpress/element";
import React, { FC, ChangeEvent } from "react";

import { useFilters } from "../../context/filters-context";

// Composant regroupant les filtres, et la logique
// de sélection de ceux-ci.
const Filters: FC = () => {
  const { filters, setFilters } = useFilters();
  const selectedDate = useMemo(() => filters.date, [filters]);
  const selectedCategorie = useMemo(() => filters.categorie, [filters]);
  const selectedType = useMemo(() => filters.type_spectacle, [filters]);
  const selectedLieu = useMemo(() => filters.lieu, [filters]);

  const onDateChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const date = e.target.value;
    const newFilters = { ...filters, date };
    setFilters(newFilters);
  };

  const onCategorieChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const categorie = e.target.value;
    const newFilters = { ...filters, categorie };
    setFilters(newFilters);
  };

  const onLieuChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const lieu = e.target.value;
    const newFilters = { ...filters, lieu };
    setFilters(newFilters);
  };

  const onTypeChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const type_spectacle = e.target.value;
    const newFilters = { ...filters, type_spectacle };
    setFilters(newFilters);
  };
  return (
    <div className="spec-filters_filters-list">
      <p>Filtrer par</p>
      {jours && jours.length > 0 && (
        <div className="spec-filters_filter">
          <select
            value={selectedDate}
            onChange={onDateChange}
            name="date"
            id="spec-filters_date"
          >
            <option value="">DATE</option>
            {jours.map((date) => (
              <option key={date.value} value={date.value}>
                {date.name}
              </option>
            ))}
          </select>
        </div>
      )}
      {categories && categories.length > 0 && (
        <div className="spec-filters_filter">
          <select
            onChange={onCategorieChange}
            value={selectedCategorie}
            name="genre"
            id="spec-filters_genre"
          >
            <option value="">GENRE</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>
      )}
      {types_spectacle && types_spectacle.length > 0 && (
        <div className="spec-filters_filter">
          <select
            onChange={onTypeChange}
            value={selectedType}
            name="type_spectacle"
            id="spec-filters_type_spectacle"
          >
            <option value="">TYPE</option>
            {types_spectacle.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
        </div>
      )}
      {lieux && lieux.length > 0 && (
        <div className="spec-filters_filter">
          <select
            value={selectedLieu}
            onChange={onLieuChange}
            name="lieu"
            id="spec-filters_lieu"
          >
            <option value="">LIEU</option>
            {lieux.map((lieu) => (
              <option key={lieu.id} value={lieu.id}>
                {lieu.name}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};

export default Filters;
